<template>
  <div class="main-dashboard-panel">
    <div class="panel-topnav container-fluid">
      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">
            Links
          </h3>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>

    <div class="container-fluid pane">
      <Links />
    </div>
  </div>
</template>

<script>
import Links from './Links'

export default {
  components: { Links },
}
</script>
